import { mulberry32, TWO_PI } from './kepler';

export interface StarField {
  count: number;
  /** xyz on a sphere */
  positions: Float32Array;
  /** linear rgb, mostly below the bloom threshold; a few are brighter */
  colors: Float32Array;
  /** point size in pixels at 1080p */
  sizes: Float32Array;
}

/**
 * The backdrop: points spread evenly over a sphere, white-blue with a few warm ones.
 * Seeded, so it never changes between visits.
 */
export function makeStarField(count = 1500, radius = 120, seed = 26000): StarField {
  const rnd = mulberry32(seed);
  const positions = new Float32Array(count * 3);
  const colors = new Float32Array(count * 3);
  const sizes = new Float32Array(count);
  for (let i = 0; i < count; i++) {
    const z = rnd() * 2 - 1, phi = rnd() * TWO_PI, rho = Math.sqrt(1 - z * z);
    positions[i * 3] = radius * rho * Math.cos(phi);
    positions[i * 3 + 1] = radius * rho * Math.sin(phi);
    positions[i * 3 + 2] = radius * z;

    // mostly faint, a handful bright enough to bloom
    const b = 0.16 + 0.7 * Math.pow(rnd(), 3.5) + (rnd() < 0.02 ? 0.5 : 0);
    const warm = Math.pow(rnd(), 3);
    colors[i * 3] = b * (0.78 + 0.22 * warm);
    colors[i * 3 + 1] = b * (0.88 + 0.02 * warm);
    colors[i * 3 + 2] = b * (1.0 - 0.28 * warm);
    sizes[i] = 2.2 + 3.2 * Math.min(1, b);
  }
  return { count, positions, colors, sizes };
}
